// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1408":"80ee5cee","2910":"0593beb0","3060":"3fc0678d","5960":"3e996937","6453":"b1ad3325","6670":"d7912e21","6856":"01c318ae","8348":"7bee46fe"}[chunkId] + ".chunk.css";
};